import { lazy } from "react"
import { PermissionProtectedRoute } from "~/router/outlets/PermissionProtectedRoute"
import { OysterRouter } from "~/router/type"
import { LazyLoadingSuspenseWithErrorBoundary } from "@oysterhr/feature-components"
import FlagProtectedRoute from "~/router/outlets/FlagProtectedRoute"

const CompanyEnrollmentsPage = lazy(() => import("./pages/CompanyEnrollmentsPage"))
const BenefitsOfferingPage = lazy(() => import("./pages/BenefitsOfferingPage"))
const CompanyRequestEnrollmentPage = lazy(() => import("./pages/CompanyRequestEnrollmentPage"))
const EnrollmentPage = lazy(() => import("./pages/EnrollmentPage"))
const EnrollmentRequestSuccessPage = lazy(() => import("./pages/EnrollmentRequestSuccessPage"))
const EnrollmentDetailsPage = lazy(() => import("./pages/EnrollmentDetailsPage"))
const EditEnrollmentPage = lazy(() => import("./pages/EditEnrollmentPage"))
const DependentEnrollmentPage = lazy(() => import("./pages/DependentEnrollmentPage"))
const CreateUpdateDependentPage = lazy(() => import("./pages/Dependents/CreateUpdateDependentPage"))

export const companyBenefitsRoutes: OysterRouter = {
  DeprecatedLeftSidebar: [
    {
      element: <PermissionProtectedRoute permissions={["benefits"]} />,
      path: "benefits",
      children: [
        {
          index: true,
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <CompanyEnrollmentsPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
        {
          index: true,
          path: "enroll/:engagementStrongId",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <CompanyRequestEnrollmentPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
        {
          index: true,
          path: "enroll/success",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <EnrollmentRequestSuccessPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
      ],
    },
    {
      path: "benefits/offering",
      element: (
        <PermissionProtectedRoute permissions={["benefits_advisor"]}>
          <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
            <BenefitsOfferingPage />
          </LazyLoadingSuspenseWithErrorBoundary>
        </PermissionProtectedRoute>
      ),
    },
    {
      element: (
        <PermissionProtectedRoute permissions={["benefits"]}>
          <FlagProtectedRoute flags={{ paBenefitsManagementForCa: true }} />
        </PermissionProtectedRoute>
      ),
      path: "benefits",
      children: [
        {
          index: true,
          path: "enroll/new/:engagementStrongId",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <EnrollmentPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
        {
          path: "enrollment/:strongId/details",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <EnrollmentDetailsPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
        {
          path: "enrollment/:enrollmentStrongId/edit",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <EditEnrollmentPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
        {
          path: "dependents/new/:employmentStrongId",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <CreateUpdateDependentPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
        {
          path: "enrollment/:enrollmentStrongId/dependent-enrollment",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <DependentEnrollmentPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
        {
          path: "enrollment/:enrollmentStrongId/dependent-enrollment/:dependentEnrollmentStrongId",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <DependentEnrollmentPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
      ],
    },
  ],
}
